<!-- components/Agendador/Amortiguadores/SistemasDireccionSuspension.vue -->
<template>
  <section class="w-full bg-BLANCO_LEON justify-center flex-col">
    <!-- Contenedor principal (equivalente a .row.rpiezas) -->
    <div
      class="
        max-w-[1460px]
        mx-auto
        mt-[40px]
        py-[30px]
        max-[600px]:py-[10px]
      "
    >
      <!-- Tabs -->
      <div class="mx-auto w-[80%] max-[600px]:w-full">
        <div
        class="
            flex items-end justify-around
            font-bold text-center
            text-[32px]
            max-[600px]:grid max-[600px]:grid-cols-2
            max-[600px]:text-[27px]
            max-[600px]:leading-[25px]
            max-[600px]:pb-[12px]
        "
        role="tablist"
        aria-label="Sistema de dirección y sistema de suspensión"
        >

          <button
            type="button"
            role="tab"
            :aria-selected="tab_activa === 'direccion'"
            :class="clase_tab('direccion')"
            @click="tab_activa = 'direccion'"
          >
            Sistema de dirección
          </button>

          <button
            type="button"
            role="tab"
            :aria-selected="tab_activa === 'suspension'"
            :class="clase_tab('suspension')"
            @click="tab_activa = 'suspension'"
          >
            Sistema de suspensión
          </button>
        </div>
      </div>

      <!-- Panel: Dirección -->
      <div
        id="direccion"
        role="tabpanel"
        :aria-hidden="tab_activa !== 'direccion'"
        v-show="tab_activa === 'direccion'"
      >
        <!-- Texto superior (equivalente a padding: 30px 120px) -->
        <div class="contenido_superior">
          <p class="texto_parrafo">
            La <strong>dirección</strong> es el conjunto de órganos. Que permiten a cualquier vehículo modificar su trayectoria.
            Para seguir el rumbo deseado. Una excepción es el caso del ferrocarril. En el que la dirección.
            Es controlada por medio de <strong>raíles y desvíos.</strong> La función primaria. De todo sistema de dirección
            es permitir al conductor. Poder guiar el vehículo hasta su destino.
          </p>

          <p class="texto_parrafo">
            En los vehículos con ruedas. Al actuar sobre el <strong>volante (o manillar).</strong> El conductor cambia el ángulo de deriva
            (ángulo entre el plano de la rueda. Y la trayectoria de la rueda). De la o las ruedas directrices.
            La fuerza creada entre la carretera. Y el eje de giro hace girar el vehículo.
          </p>
        </div>

        <h2 class="titulo_seccion_rojo">PIEZAS DE DIRECCIÓN</h2>

        <!-- Cards dirección (equivalente a .row.cpiezas) -->
        <div class="cpiezas">
          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/Cremallera-de-direccion-2.png"
              alt="Cremallera de dirección"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">CREMALLERA DE DIRECCIÓN</h3>
              <p class="texto_card">
                Contribuye a la direccionalidad del vehículo. Mediante el volante de dirección se comanda la cremallera dando al vehículo la dirección a donde se dirige.
              </p>
            </div>
          </article>

          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/terminales2.png"
              alt="Extremos de dirección"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">EXTREMOS DE DIRECCIÓN</h3>
              <p class="texto_card">
                Conecta el precap con la masa de rueda, cumpliendo la función de direccionar ambas masas como también el movimiento activo de las ruedas.
              </p>
            </div>
          </article>

          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/masa2.png"
              alt="Masa de rueda"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">MASA DE RUEDA</h3>
              <p class="texto_card">
                Se encarga de proteger la fricción del eje, permitiendo que las llantas puedan girar libremente y puedan tener una total seguridad al conducir
              </p>
            </div>
          </article>

          <article class="piezas piezas_full" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/Precap2.png"
              alt="Precap o articulación axial"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">PRECAP O ARTICULACIÓN AXIAL</h3>
              <p class="texto_card">
                Por un lado, se encuentra sujeto a la cremallera de dirección y por el otro, al extremo de dirección. Se utiliza en los sistemas de dirección con cremallera,
                garantizando una deflexión angular considerable. Su función es transmitir fuerzas axiales a la rótula de dirección y, de esta manera, permite que las ruedas
                giren proporcionando un buen balance en el sistema.
              </p>
            </div>
          </article>
        </div>
      </div>

      <!-- Panel: Suspensión -->
      <div
        id="suspension"
        role="tabpanel"
        :aria-hidden="tab_activa !== 'suspension'"
        v-show="tab_activa === 'suspension'"
      >
        <div class="contenido_superior">
          <p class="texto_parrafo">
            Conecta las ruedas al chasis y utiliza muelles, amortiguadores, barras de unión y brazos de control para amortiguar el impacto y permitir el movimiento relativo.
          </p>
        </div>

        <h2 class="titulo_seccion_rojo">PIEZAS DE SUSPENSIÓN</h2>

        <div class="cpiezas">
          <!-- 3 cards pequeñas -->
          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/ROTULA-1.png"
              alt="Rótula"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">RÓTULA</h3>
              <p class="texto_card">
                Es el enlace entre los elementos de la suspensión, la dirección y el movimiento direccional de las ruedas, para que el conjunto pueda girar.
              </p>
            </div>
          </article>

          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/CAZOLETA-1.png"
              alt="Cazoleta"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">CAZOLETA</h3>
              <p class="texto_card">
                Sostiene el espiral y a la vez filtra las vibraciones del conjunto de suspensión con respecto a la carrocería.
              </p>
            </div>
          </article>

          <article class="piezas piezas_small" align="center">
            <img
              class="pieza-img"
              src="/img/trendelantero/BARRA-ESTABILIZADORA-1.png"
              alt="Barra estabilizadora"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body">
              <h3 class="titulo_card">BARRA ESTABILIZADORA</h3>
              <p class="texto_card">
                Equilibra las diferencias de pesos entre la suspensión de un lado y el otro.
              </p>
            </div>
          </article>

          <!-- 2 cards mitad (md 48%) -->
          <article class="piezas piezas_half" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/PARRILLA-DE-SUSPENSION-1.png"
              alt="Parrilla de suspensión"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">PARRILLA DE SUSPENSIÓN</h3>
              <p class="texto_card">
                Es la responsable de unir la rueda a la carrocería o chasis. De esta forma, la rueda puede tener movimientos de arriba hacia abajo, mientras el habitáculo se
                mantiene estable y firme. Está compuesta por una estructura que puede ser de fabricación en chapa estampada, forja o fundición y aluminio. Además, la componen
                una o dos rótulas, dependiendo del modelo, y bujes.
              </p>
            </div>
          </article>

          <article class="piezas piezas_half" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/BUJES-DE-LA-PARRILLA-1.png"
              alt="Bujes de la parrilla"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">BUJES DE LA PARRILLA</h3>
              <p class="texto_card">
                Los anclajes de las parrillas de suspensión, brazo de rotula, tensor, barra estabilizadora, están conectados a través de bujes. El buje es una goma dura que cumple
                la función de quitarle el ruido al tren delantero y proporcionarle elasticidad, puesto que de lo contrario, las fricciones entre metales serían ruidosas.
              </p>
            </div>
          </article>

          <!-- 4 cards full -->
          <article class="piezas piezas_full" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/BIELETAS-1.png"
              alt="Bieleta"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">BIELETA</h3>
              <p class="texto_card">
                La bieleta es un componente rígido formado por dos rótulas, generalmente roscadas, las cuales se ubican una en cada extremo de la misma. Su función consiste en
                acoplar la barra estabilizadora con todo el conjunto de suspensión. Permite movimientos en cualquier sentido, contribuyendo de forma activa en todo el recorrido de la
                dirección, así como a la estabilidad y maniobrabilidad del vehículo. Se suele encontrar en el tren delantero de los vehículos, aunque en algunos casos también se las
                puede localizar en el tren trasero.
              </p>
            </div>
          </article>

          <article class="piezas piezas_full" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/AMORTIGUADORES_-_-1.png"
              alt="Amortiguadores"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">AMORTIGUADORES</h3>
              <p class="texto_card">
                Protegen de golpes, impactos y vibraciones tanto a los pasajeros como al resto de elementos del automóvil. Los principales cometidos que cumplen los amortiguadores se
                encuentran el control de las oscilaciones de la suspensión para ganar adherencia a la vía, la mejora de la estabilidad en las curvas, la reducción de la distancia de
                frenado y el hecho de volver la marcha más confortable al absorber las irregularidades del terreno.
              </p>
            </div>
          </article>

          <article class="piezas piezas_full" align="left">
            <img
              class="pieza-img"
              src="/img/trendelantero/ESPIRALES-1.png"
              alt="Espirales"
              loading="lazy"
              decoding="async"
            />
            <div class="pieza-body pieza-body_full">
              <h3 class="titulo_card">ESPIRALES</h3>
              <p class="texto_card">
                Son los que mantienen e impiden que las vibraciones sufridas por las ruedas se transmitan a los pasajeros. Cuando una rueda supera un obstáculo, el resorte es comprimido
                acumulando energía que hará distender al resorte y oscilar varias veces hasta encontrar su equilibrio.
              </p>
            </div>
          </article>
        </div>
      </div>
    </div>

    <!-- Bloque "TIEMPO DE DESGASTE" -->
    <div class="relative max-w-[1440px] bg-cover bg-center py-[20px] rounded-2xl mx-auto"
      :style="{
        backgroundImage: `url('/img/trendelantero/Group_17.jpg')`
      }"
    >
      <!-- 
        Overlay para asegurar legibilidad 
        <div class="absolute inset-0 bg-black/55"></div>
      -->

      <div class="relative mx-auto w-full">
        <div class="flex flex-col-reverse md:flex-row">
          <!-- Col izquierda: imagen -->
          <div class="img-tren2 relative w-full md:w-1/2">
            <img
              class="img-tren2__img"
              src="/img/trendelantero/tren_%202.png"
              alt="Tren delantero (referencial)"
              loading="lazy"
              decoding="async"
            />
          </div>

          <!-- Col derecha: texto -->
          <div class="textotren2 w-full md:w-1/2">
            <div class="flex items-start">
              <img
                src="/img/trendelantero/Vector.png"
                alt=""
                width="20"
                height="26"
                class="mt-[4px] mr-[5px]"
                aria-hidden="true"
              />
              <h2 class="text-white font-bold">TIEMPO DE DESGASTE</h2>
              <img
                src="/img/trendelantero/Frame.png"
                alt=""
                width="36"
                height="36"
                class="ml-[10px] mt-[-2px]"
                aria-hidden="true"
              />
            </div>

            <p class="text-white mt-3">
              Aunque las partes de la suspensión están expuestas al mismo kilometraje, algunas se desgastan más rápidamente. Cualquiera de las partes está en el lado que recibe
              más castigo por golpear bordillos o sobre baches, por ejemplo. Además, los componentes que soportan una carga más pesada. ¡Las rótulas cargadas tienen que trabajar
              duro y deteriorarse más rápido que sus equivalentes sin carga!
            </p>

            <p class="text-white mt-4">
              Es importante mantenerse al tanto de cualquier reparación de la suspensión delantera. Una pieza desgastada puede empezar a afectar rápidamente a otras, causando
              estrés adicional y presión indebida en otros lugares. La seguridad del conductor es, por supuesto, una prioridad absoluta, por lo que es vital abordar los problemas
              de la parte delantera para que el coche pueda manejarse de forma segura y rendir al máximo.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

const tab_activa = ref('direccion');

const clase_tab = (id) => {
  const activa = tab_activa.value === id;

  return [
    // Base
    'bg-transparent',
    'border-0 border-b-4 border-solid', // ✅ asegura que exista la raya inferior
    'pb-2',
    'font-bold',
    'transition-colors duration-200',
    'focus:outline-none',

    // Desktop: subrayado del ancho del texto (con padding como Bootstrap nav-link)
    'w-fit px-4',

    // Mobile: ocupa el ancho de la columna (como tu maqueta mobile)
    'max-[600px]:w-full max-[600px]:px-0',

    // Estado
    activa
      ? 'text-[#BE2B27] border-b-4 border-[#BE2B27]'
      : 'text-black border-black'
  ].join(' ');
};


</script>

<style scoped>
/* =========================
   Tipografías / espaciados base
   ========================= */
.contenido_superior {
  padding: 30px 120px;
}
.texto_parrafo {
  font-size: 16px;
  line-height: 1.45;
  margin: 0 0 14px 0;
  color: #1f2937; /* gris oscuro legible */
}
.titulo_seccion_rojo {
  color: var(--ROJO_TITULOS_LEON);
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: 0.04em;
  margin-top: 10px;
  margin-bottom: 0;
}
.cpiezas {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

/* Card base (equivalente a .piezas legacy) */
.piezas {
  border: 3px solid #8080805e;
  border-radius: 15px;
  padding: 20px;
  margin: 10px;
  background: #fff;
  position: relative;
  overflow: visible;
}

/* tamaños desktop equivalentes a max-width 32% / 48% / 99% */
.piezas_small {
  width: 100%;
}
.piezas_half {
  width: 100%;
}
.piezas_full {
  width: 100%;
}

/* Imagen hover (legacy: scale 1.1 + 1s) */
.pieza-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: -25px;
  padding-bottom: 16px;
  transition: transform 1s;
}
.pieza-img:hover {
  transform: scale(1.1);
}

/* Texto en cards */
.pieza-body {
  text-align: center;
}
.pieza-body_full {
  padding: 40px 0px;
  text-align: left;
}
.titulo_card {
  font-weight: 700;
  margin-top: 10px;
  font-size: 28px;
}
.texto_card {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.45;
}

/* =========================
   "Tiempo de desgaste" (legacy)
   ========================= */
.textotren2 {
  padding: 70px 70px;
}
.textotren2 h2 {
  font-size: 32px;
}
.img-tren2__img {
  position: absolute;
  z-index: 99;
  right: 0px;
  width: 100%;
  top: 15px;
  transition: transform 1s;
}
.img-tren2__img:hover {
  transform: scale(1.1);
}

/* =========================
   Responsive: mobile (<=600px) EXACTO al CSS legacy
   ========================= */
@media (max-width: 600px) {
  .contenido_superior {
    padding: 30px 20px;
  }
  .titulo_card {
    font-size: 20px;
  }

  /* Cards: forzar layout tipo legacy (imagen absoluta a la izquierda) */
  .cpiezas .piezas {
    max-width: 100% !important;
  }
  .cpiezas .piezas .pieza-body {
    width: 74%;
    float: right;
    padding: 5px 0px 5px 25px !important;
    text-align: left;
  }
  .cpiezas .piezas .pieza-img {
    position: absolute;
    bottom: 50%;
    width: 39% !important;
    left: -20px;
    margin-top: 0;
    padding-bottom: 0;
  }

  /* Ajustes Dirección (nth-child exactos) */
  #direccion .cpiezas .piezas:nth-child(1) .pieza-img {
    bottom: 36% !important;
    width: 39% !important;
    margin-left: 3px;
  }
  #direccion .cpiezas .piezas:nth-child(2) .pieza-img {
    bottom: 32% !important;
    width: 35% !important;
  }
  #direccion .cpiezas .piezas:nth-child(3) .pieza-img {
    bottom: 13% !important;
    width: 33% !important;
  }

  /* Ajustes Suspensión (exactos) */
  #suspension .cpiezas .piezas .pieza-img {
    bottom: 22% !important;
    width: 29% !important;
    left: -1px;
  }
  #suspension .cpiezas .piezas:nth-child(2) .pieza-img {
    bottom: 9% !important;
    width: 37% !important;
    left: -16px;
  }
  #suspension .cpiezas .piezas:nth-child(3) .pieza-img {
    bottom: 33% !important;
    width: 36% !important;
    left: -12px;
  }
  #suspension .cpiezas .piezas:nth-child(4) .pieza-img {
    bottom: 33% !important;
    width: 29% !important;
    left: -12px;
  }
  #suspension .cpiezas .piezas:nth-child(5) .pieza-img {
    bottom: 37% !important;
    width: 33% !important;
    left: -3px;
  }
  #suspension .cpiezas .piezas:nth-child(6) .pieza-img {
    bottom: 44% !important;
    width: 33% !important;
    left: -3px;
  }
  #suspension .cpiezas .piezas:nth-child(7) .pieza-img {
    bottom: 30% !important;
    width: 27% !important;
    left: 11px;
  }

  /* Nota: este componente trae 7 piezas en suspensión.
     Si más adelante agregas una 8va, puedes reactivar el selector nth-child(8). */

  /* "Tiempo de desgaste" mobile (legacy) */
  .textotren2 {
    padding: 20px 25px;
  }
  .textotren2 h2 {
    font-size: 27px;
  }
  .img-tren2__img {
    position: initial;
    width: 100%;
    top: auto;
    right: auto;
  }
}

/* =========================
   Responsive: desktop 1400-1800 (exacto legacy)
   ========================= */
@media screen and (min-width: 1400px) and (max-width: 1800px) {
  /* Dirección: ajustes de ancho por pieza */
  #direccion .cpiezas .piezas:nth-child(1) .pieza-img {
    width: 100% !important;
  }
  #direccion .cpiezas .piezas:nth-child(2) .pieza-img {
    width: 60% !important;
  }
  #direccion .cpiezas .piezas:nth-child(3) .pieza-img {
    width: 43% !important;
  }
  #direccion .cpiezas .piezas:nth-child(4) .pieza-img {
    margin-top: 3% !important;
  }

  /* Suspensión: ajustes */
  #suspension .cpiezas .piezas:nth-child(1) .pieza-img {
    width: 50% !important;
  }
  #suspension .cpiezas .piezas:nth-child(2) .pieza-img {
    width: 90% !important;
    margin-top: 7px;
  }
  #suspension .cpiezas .piezas:nth-child(3) .pieza-img {
    width: 90% !important;
    padding-top: 3rem !important;
  }
  #suspension .cpiezas .piezas:nth-child(4) .pieza-img {
    margin-top: 29% !important;
    width: 34%;
  }
  #suspension .cpiezas .piezas:nth-child(5) .pieza-img {
    margin-top: 26% !important;
    width: 38%;
  }
  #suspension .cpiezas .piezas:nth-child(6) .pieza-img {
    margin-top: 7% !important;
    width: 21% !important;
  }
  #suspension .cpiezas .piezas:nth-child(7) .pieza-img {
    margin-top: 1% !important;
    width: 11% !important;
  }

  /* "Tiempo de desgaste" padding desktop (legacy) */
  .textotren2 {
    padding: 70px 50px;
  }
}

/* =========================
   Breakpoints Tailwind-like para widths de cards (md+)
   (Equivalente a max-width 32% / 48% / 99%)
   ========================= */
@media (min-width: 768px) {
  .piezas_small {
    max-width: 31.9% !important;
  }
  .piezas_half {
    max-width: 48% !important;
  }
  .piezas_full {
    max-width: 99% !important;
  }

  /* Full / Half: imagen a la izquierda (equivalente a floats legacy) */
  .piezas_half .pieza-img {
    float: left;
    width: 25%;
    margin-top: 3px;
    margin-right: 15px;
    padding-bottom: 0;
  }
  .piezas_full .pieza-img {
    float: left;
    width: auto;
    max-width: 20%;
    max-height: 290px;
    margin-top: -25px;
    margin-right: 15px;
    padding-bottom: 0;
  }
}
</style>
